module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "western2",
    attrs: {
      "id": "calibre_pb_7"
    }
  }, [_c('a', {
    attrs: {
      "id": "CHAPTER01"
    }
  }), _vm._v("\nCHAPTER 1")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c8"
  }, [_vm._v("JOURNAL ENTRY: July 29")]), _vm._v(" "), _c('p', {
    staticClass: "c"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("I woke early, depressed that the ash from the\nYellowstone eruption has moved back in. While I was in the kitchen\nmaking coffee, I was startled by the bright sunlight coming through\nthe glass door. Apparently the ash clouds last night were a fluke\nor very small, either way I was delighted to see the sun\nshining.")]), _vm._v(" "), _c('p', {
    staticClass: "c"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c"
  }, [_vm._v("*")]), _vm._v(" "), _c('p', {
    staticClass: "c"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("“What an amazing day it is!” Mark proclaimed\nwith unbridled enthusiasm, looking out the door to admire the\nbright sun. He was suddenly somber. I turned to him, questioning\nhis unusual silence.")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("“Marry me,” he stated in all seriousness. “I\nknow it seems sudden …”")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("“… but it’s not sudden to me. I— what did you\nsay?”")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("“I said yes, Mark. I’ll marry you.\nConditional on your answer to two questions: Do you love me? And\nwill you promise to never leave me?”")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("Mark took my hands and searched my face.\n“Yes, Allex, I love you deeply, so much so it surprises me. As for\nleaving you, it will be ‘until death do us part’.”")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("I grinned with excitement. “Then yes, let’s\nget married.”")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("“I do need to ask, Allex, why me? You turned\nJohn down, after all you two had been through together.”")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("I didn’t need to think about my answer. “I\nbelieve that as much as I loved John, and I still do, John is a\nwanderer. I’m still not sure why he asked me, because he knows he\nalways leaves – always. Some part of me felt he asked out of\ngratitude for taking him in last winter, and that’s not a good\nreason to get married. I knew deep in my soul it wasn’t a forever\nthing, and I want forever. With you it’s different. We "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("will")]), _vm._v("\nhave a life together. Does that make sense?”")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("“Perfectly! When shall we do this?”")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("“Let’s go and talk to Pastor Carolyn\ntomorrow, if that’s okay with you,” I replied. “Tonight we\ncelebrate.” I kissed the man that would become my husband. “Oh, and\nwe need to tell the boys.”")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c"
  }, [_vm._v("~~~")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("“Your m-mother and I… h-have made a\ndecision,” Mark stuttered.")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("“Mark asked me to marry him and I said yes,”\nI finished.")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("Both Eric and Jason looked shocked, but not\nas shocked as Amanda.")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("“Well, say something!” I said, aghast and\nsomewhat offended at their silence.")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("“Isn’t this rather sudden, Mom?” Jason said.\n“I mean, you haven’t known each other very long, and have dated for\nwhat, two weeks?”")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("“We’ve known each other for three months and\nyou can’t call living in the same house dating. The world has\nchanged, or haven’t you three noticed? I’m going to grab onto this\nhappiness I’ve found with Mark,” I said, disappointed at their\nreaction.")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("“What if John comes back?” Amanda asked in a\nsmall voice.")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("So that’s what this was about. “If John comes\nback, which I don’t think he will, then he’ll find out that his\nleaving had consequences. I love Mark and he loves me, and we’re\ngetting married. Now, do you three want to help us plan a\nwedding?”")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("Eric stepped forward on his crutches and gave\nme a hug, while extending his hand to Mark. “If you’re happy, Mom,\nthen we’re happy!”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27f7c900","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_648f5cba11b35594391da1bef1608eec_YkgYR9.ch.fixed.fc.tidied.stylehacked.xfixed_split_008.vue
// module id = 84
// module chunks = 0